<template>
  <el-dialog
    title="人群分析"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    width="660px"
    @close="close"
  >
  
  <div slot="title" class="dialog-title">人群分析:【{{ dTitle }}】</div>
    <div class="tips-content">
      <div class="alert_box">
        <div class="alert">
          <img
            src="@/assets/images/new_icon_waring_yellow.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 0px;
            "
          />
          人群分析从执行后第二天开始统计，最多统计执行后30天的数据
        </div>
      </div>
    </div>
    <el-form
      :model="analyzeForm"
      :label-width="formLabelWidth"
      inline
      style="text-align: left"
      :rules="rules"
      ref="ruleForm"
    >
    
      <!-- 时间选择器：1.立即执行和定时执行时显示 -->
      <div
        style="display: inline-block; margin-top: -10px; margin-bottom: 20px"
      >
        <span style="margin-top: 10px">分析时间：</span>
        <el-select
          v-model="twoValue"
          placeholder="请选择"
          size="small"
          @change="chooseTimeSelect(twoValue, '1')"
          style="width: 96px; margin-top: 10px"
        >
          <el-option
            v-for="item in twoOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option> </el-select
        >&nbsp;&nbsp;
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="analyzeForm.analysisStartTime"
            type="datetime"
            :placeholder="'选择日期时间'"
            :disabled="twoValue != 0"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div v-if="twoValue != 0" class="time_to_text1">至</div>
          <div v-else class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            :disabled="twoValue != 0"
            v-model="analyzeForm.analysisEndTime"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i
            class="el-icon-circle-close date_icon1"
            @click="clearTimeSendTime"
            :disabled="twoValue != 0"
          ></i>
          <img
            src="@/assets/images/select_date.svg"
            alt
            class="date_icon2"
            :disabled="twoValue != 0"
          />
        </div>
        &nbsp;&nbsp;
        <el-button @click="searchAnaly" v-if='this.marketStatus == 6' >查询</el-button>
      </div>
      <div>
        <!-- 分析批次：1.周期执行才显示  -->
        <div class="lineBox" v-if='this.marketStatus == 5'>
          <span>分析批次：</span>
          <el-select
            v-model="analyzeForm.id"
            placeholder="请选择"
            style="width: 388px"
            @change = batch
          >
            <el-option
              v-for="item in batchIds"
              :key="item.id"
              :label="item.cycleExecutionDatetime"
              :value="item.id"
              @click.native="neverTime(item.cycleExecutionDatetime, '1')"
            >
              {{ item.cycleExecutionDatetime }}
            </el-option>
          </el-select>
          &nbsp;&nbsp;&nbsp;&nbsp;
         <el-button @click="searchAnaly" v-if='this.marketStatus == 5' >查询</el-button>
        </div>
      </div>
      &nbsp;&nbsp;
      <!-- 列表数据 -->
      <div>
        <div class="box">
          <div class="boxTitle">
            <span class="divison"></span>
            <span>人群基本情况</span>
          </div>
          <div class="contenClass">
            <div>
                <span>人群数量：</span>
                <span>{{crowdObject.crowdNum}} 人</span>
            </div>
            <div>
                <span>关注店铺人数：</span>
                <span>{{crowdObject.followNum}} 人</span>
            </div>
            <div>
                <span>进店人数：</span>
                <span>{{crowdObject.inShopNum}} 人</span>
            </div>
            <div>
                <span>加购人数：</span>
                <span>{{crowdObject.addCartNum}} 人</span>
            </div>
            <div>
                <span>下单人数：</span>
                <span>{{crowdObject.orderNum}} 人</span>
            </div>
            <div>
                <span>成交人数：</span>
                <span>{{crowdObject.finishNum}} 人</span>
            </div>
          </div>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="box">
          <div class="boxTitle">
            <span class="divison"></span>
            <span>人群进阶情况</span>
          </div>
          <div class="contenClass">
            <div>
                <span>店铺关注率：</span>
                <span>{{crowdObject.followRate}}%</span>
            </div>
            <div>
                <span>浏览率：</span>
                <span>{{crowdObject.inShopRate}}%</span>
            </div>
            <div>
                <span>加购率：</span>
                <span>{{crowdObject.addCartRate}}%</span>
            </div>
            <div>
                <span>下单率：</span>
                <span>{{crowdObject.orderRate}}%</span>
            </div>
            <div>
                <span>下单-成交率：</span>
                <span>{{crowdObject.orderFinishRate}}%</span>
            </div>
            <div>
                <span>成交转化率：</span>
                <span>{{crowdObject.finishRate}}%</span>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div  style="text-align: right;margin-top:20px">
      <!-- <el-button @click="viewVisible = false">取消</el-button> -->
      <el-button type="primary" @click="viewVisible = false">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
//   import manalyze from "@/api/market/intelligent/m_analyze.js";
import moment from "moment";
import Alert from "@/components/common/myAlert.vue";
export default {
  name: "analyzeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketStatus: null,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Alert,
  },
  created() {
    mnode.getNode({ nodeId: this.nodeId }).then((res) => {
      if (res.code === 1 && res.data) {
        this.dTitle = res.data.name;
        //分析批次
        if (this.marketStatus == 5) {
          mnode.getExecRecordList(this.marketingId).then((res) => {
         
              this.batchTime = res.data;
              this.analyzeForm.analysisStartTime =
              this.batchTime[0].cycleExecutionDatetime;
              this.analyzeForm.analysisEndTime = moment(
               new Date(
                new Date(this.batchTime[0].cycleExecutionDatetime).getTime() +
                  parseInt(7) * 24 * 60 * 60 * 1000
              )
             ).format("YYYY-MM-DD HH:mm:ss");
            this.neverTime(this.batchTime[0].cycleExecutionDatetime);
            if (res.data.length) {
              this.$data.batchIds = res.data;
              this.execRecordIds = this.batchTime[0].id;
              this.analyzeForm.id = this.batchTime[0].id;
            }
          });
          setTimeout(()=>{
             this.search();
          },1000)
        }
        //状态不等于2和6的，不需要分析批次,不是周期执行的话不用传execRecordIds,时间是往前推
        if (this.marketStatus == 6) {
          mnode.getExecRecordList(this.marketingId).then((res) => {
            this.batchTime = res.data;
            let times = moment(
              new Date(
                new Date(this.batchTime[0].cycleExecutionDatetime).getTime() +
                  parseInt(7) * 24 * 60 * 60 * 1000
              )
            ).format("YYYY-MM-DD HH:mm:ss");
            this.analyzeForm.analysisStartTime = this.batchTime[0].cycleExecutionDatetime; 
            this.analyzeForm.analysisEndTime = times;
            this.neverTime(this.batchTime[0].cycleExecutionDatetime);
          });
          setTimeout(()=>{
            this.search();
          },1000)
        }
      }
    });
  },
  mounted() {
    this.handleShowPremission();
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  watch: {},
  data() {
    return {
      dTitle:null,
      isPremissionShow: false,
      execRecordIds: "",
      crowdObject: {
        crowdNum: "", //人群数量
        followNum: "", //关注店铺人数
        inShopNum: "", //进店人数
        addCartNum: "", //加购人数
        orderNum: "", //下单人数
        finishNum: "", //成交人数
        followRate: "", //店铺关注数
        inShopRate: "", //浏览率
        addCartRate: "", //加购率
        orderRate: "", //下单率
        orderFinishRate: "", //下单-成交率
        finishTransRate: "", //成交转换率
      },
      customerBlock: false,
      analyzeForm: {
        smartMarketingNodeId: "",
        smsBatchId: "",
        analysisStartTime: "",
        analysisEndTime: "",
        after_day: 7,
      },
      formLabelWidth: "80px",
      rules: {
        after_day: [
          { required: true, message: "请输入周期", trigger: "blur" },
          {
            pattern: /^[1-7]{1}$/,
            message: "周期必须为数字值,1-7之间",
            trigger: "blur",
          },
        ],
      },
      batchIds: [],
      twoOptions: [
        {
          value: "3",
          label: "近3天",
        },
        {
          value: "7",
          label: "近7天",
        },
        {
          value: "15",
          label: "近15天",
        },
        {
          value: "30",
          label: "近30天",
        },
        {
          value: "0",
          label: "自定义",
        },
      ],
      twoValue: "7", //短信分析时间

      analyzing: "0",
      dataEmp: "",
      monetTime: "", //选择时间
      batchTime: [],
      chooseOneData: {},

      isquery: false,
      ROIRate: 0,

      fullChartData: "",
      tempData: null,
      tabsActiveName: "first",
      fullOverview: [],
      loading: true,
      dataEmpty: true,
      customerForm: {
        smsBatchId: "",
        buyerNick: "",
        numIid: "",
        customerType: "0",
        pageNum: 1,
        pageSize: 10,
        recordCount: 0,
      },
      customerData: [],
      customerTypes: [
        {
          value: "1",
          label: "拍单客户",
        },
        {
          value: "2",
          label: "成交客户",
        },
        {
          value: "4",
          label: "拍单未付款客户",
        },
        {
          value: "5",
          label: "退款客户",
        },
      ],
      analysisTypes: [
        {
          value: "0",
          label: "商品付款",
        },
        {
          value: "1",
          label: "商品询单",
        },
        {
          value: "2",
          label: "商品加购",
        },
        {
          value: "3",
          label: "商品收藏",
        },
      ],
      shopTypes: [
        {
          value: "1",
          label: "拍单商品",
        },
        {
          value: "2",
          label: "成交商品",
        },
        {
          value: "4",
          label: "拍单未付款商品",
        },
        {
          value: "5",
          label: "退款商品",
        },
      ],
      sorderForm: {
        smsBatchId: "",
        buyerNick: "",
        tid: "",
        receivedPaymentStart: "",
        receivedPaymentEnd: "",
        customerType: "",
        pageNum: 1,
        pageSize: 10,
        recordCount: 0,
      },
      sorderData: [],
      productForm: {
        smsBatchId: "",
        numIid: "",
        itemType: "",
        pageNum: 1,
        pageSize: 10,
        recordCount: 0,
      },
      productData: [],
      orderMin: "first",
      exportLoading: true,
      forId:''
    };
  },
  methods: {
    batch(e){
      this.search(e);
      this.forId = e;
    },
    clearTimeSendTime() {
      this.analyzeForm.analysisStartTime = "";
      this.analyzeForm.analysisEndTime = "";
    },
    handleShowPremission() {
      if (
        this.permissions &&
        this.permissions.indexOf("hide:crowdAnalysis") != "-1"
      ) {
        // 显示和屏蔽人群分析按钮
        this.isPremissionShow = true;
      }
    },
    searchAnaly() {
      //周期执行
      if(this.$route.query.executionType == 2){
        let id = this.forId?this.forId:this.execRecordIds
        this.search(id);
      }else{
        this.search();
      }
    },
    //人群分析数据
    search(e) {
      console.log(e,'35656565');
      let params = {
        nodeId: this.nodeId,
        startTime: this.analyzeForm.analysisStartTime,
        endTime: this.analyzeForm.analysisEndTime,
        execRecordId:this.execRecordIds
      };
      if(this.$route.query.executionType == 2){
        params.execRecordId = e?e:this.execRecordIds
      }
      mnode.crowdAnalys(params).then((res) => {
        this.crowdObject = { ...res.data };
      });
    },
    //时间选择
    neverTime(value) {
      this.monetTime = value;
    },
    //修改成自定义时间
    chooseTimeSelect(val, type) {
      var start = this.monetTime;
      if (this.marketStatus == 5) {
        let end = moment(
          new Date(
            new Date(this.monetTime).getTime() +
              parseInt(val) * 24 * 60 * 60 * 1000
          )
        ).format("YYYY-MM-DD HH:mm:ss");
        this.analyzeForm.analysisStartTime = val == 0 ? "" : start;
        this.analyzeForm.analysisEndTime = val == 0 ? "" : end;
      }
      if (this.marketStatus == 6) {
        let end = moment(
          new Date(
            new Date(this.monetTime).getTime() +
              parseInt(val) * 24 * 60 * 60 * 1000
          )
        ).format("YYYY-MM-DD HH:mm:ss");
        this.analyzeForm.analysisStartTime = val == 0 ? "" : start;
        this.analyzeForm.analysisEndTime = val == 0 ? "" : end;
      }
    },
    //分页变化
    handleSizeChange(val) {
      this.customerForm.pageNum = 1;
      this.customerForm.pageSize = val;
      this.getCustomerDetailList();
    },
    //当前页发生变化
    queryCurrentChange(val) {
      this.customerForm.pageNum = val;
      this.getCustomerDetailList();
    },
    //确定
    getCustomerDetailListSure() {
      this.customerForm.pageNum = 1;
      this.getCustomerDetailList();
    },
    //分析类型事件
    analyzingChange(val) {
      this.analyzing = val;
      this.getCustomerDetailList();
    },
    // 跳到对应商品购买页
    toGoodDetail(val) {
      if (val.length > 0) {
        window.open(val, "_blank");
      }
    },
    analyzeSubmit() {
      if (this.orderMin == "second") {
        this.getCustomerDetailListSure();
      } else if (this.orderMin == "third") {
        this.getOrderDetailList();
      } else if (this.orderMin == "fourth") {
        this.getItemDetailList();
      } else if (this.orderMin == "first") {
        this.queryData();
      }
    },
    handleClick(val) {
      this.orderMin = val;
      switch (val) {
        case "first":
          this.queryData();
          break;
        case "second":
          (this.customerForm = {
            smsBatchId: "",
            buyerNick: "",
            numIid: "",
            customerType: "0",
            pageNum: 1,
            pageSize: 10,
            recordCount: 0,
          }),
            (this.analyzing = "0");
          this.getCustomerDetailList();
          break;
        case "third":
          this.getOrderDetailList();
          break;
        case "fourth":
          this.getItemDetailList();
          break;
      }
    },
    getCustomerDetailList() {
      let data = JSON.parse(JSON.stringify(this.customerForm));
      let params = {
        current: data.pageNum,
        size: data.pageSize,
        type: this.analyzing,
        endTime: this.analyzeForm.analysisEndTime,
        startTime: this.analyzeForm.analysisStartTime,
        itemId: this.customerForm.numIid,
        nodeId: this.nodeId,
      };
      //Note---淘宝v3.21迭代
      mnode.analysisGoodsReportGet(params).then((res) => {
        if (res.data) {
          this.customerData = res.data.records;
          this.customerForm.recordCount = res.data.total;
        } else {
          this.customerData = [];
          this.customerData.recordCount = 0;
        }
      });
    },
    getOrderDetailList() {
      let data = JSON.parse(JSON.stringify(this.sorderForm));
      data.smsBatchId = this.analyzeForm.smsBatchId;
      data.tradeCreateStartTime = this.analyzeForm.analysisStartTime;
      data.tradeCreateEndTime = this.analyzeForm.analysisEndTime;
      manalyze.getBatchMarketingTradeDetail(data).then((res) => {
        if (res.data) {
          this.sorderData = res.data.dataList;
          this.sorderForm.recordCount = res.data.pageInfo.total;
        } else {
          this.sorderData = [];
          this.sorderForm.recordCount = 0;
        }
      });
    },
    sorderCurrentChange(val) {
      this.sorderForm.pageNum = val;
      this.getOrderDetailList();
    },
    getItemDetailList() {
      let data = JSON.parse(JSON.stringify(this.productForm));
      data.smsBatchId = this.analyzeForm.smsBatchId;
      data.tradeCreateStartTime = this.analyzeForm.analysisStartTime;
      data.tradeCreateEndTime = this.analyzeForm.analysisEndTime;
      manalyze.getBatchMarketingItemDetail(data).then((res) => {
        if (res.data) {
          this.productData = res.data.dataList;
          this.productForm.recordCount = res.data.pageInfo.total;
        } else {
          this.productData = [];
          this.productForm.recordCount = 0;
        }
      });
    },
    productCurrentChange(val) {
      this.productForm.pageNum = val;
      this.getItemDetailList();
    },
    queryData() {
      this.exportLoading = true;
      let afterDay = this.analyzeForm.after_day;
      this.analyzeForm.nodeId = this.nodeId;
      this.analyzeForm.startTime = this.analyzeForm.analysisStartTime;
      this.analyzeForm.endTime = this.analyzeForm.analysisEndTime;
      manalyze.analysisReportGet(this.analyzeForm).then((res) => {
        this.exportLoading = false;
        if (res.code === 200) {
          this.$message.success(res.message);
          let fullOverview = [];
          let data = res.data;
          let sumPrice = 0;
          let sumMsg = 0;
          // 目标客户数据
          if (data) {
            //Note:迭代需求添加字段，；联调直接放开就好
            let tData = [
              { label: "分析人数", value: "0", unit: "人" },
              { label: "收藏人数", value: "0", unit: "人" },
              { label: "加购人数", value: "0", unit: "人" },
              { label: "询单人数", value: "0", unit: "人" },
            ];
            tData[0].value = data.MARKET_CROWD_UV ? data.MARKET_CROWD_UV : "--";
            tData[1].value = data.MARKET_CROWD_COLLECT_ITEM_UV
              ? data.MARKET_CROWD_COLLECT_ITEM_UV
              : "--";
            tData[2].value = data.MARKET_CROWD_CART_UV
              ? data.MARKET_CROWD_CART_UV
              : "--";
            tData[3].value = data.MARKET_CROWD_CONSULT_ITEM_UV
              ? data.MARKET_CROWD_CONSULT_ITEM_UV
              : "--";
            fullOverview.push({
              name: "目标客户",
              data: tData,
            });
          }
          // 拍单客户数据
          if (data) {
            let bData = [
              { label: "店铺首页PV", value: "0", unit: "" },
              { label: "店铺首页UV：", value: "0", unit: "" },
              { label: "商品详情页PV", value: "0", unit: "" },
              { label: "商品详情页UV", value: "0", unit: "" },
            ];
            bData[0].value = data.MARKET_CROWD_SHOP_PV
              ? data.MARKET_CROWD_SHOP_PV
              : "--";
            bData[1].value = data.MARKET_CROWD_SHOP_UV
              ? data.MARKET_CROWD_SHOP_UV
              : "--";
            bData[2].value = data.MARKET_CROWD_DETAIL_PV
              ? data.MARKET_CROWD_DETAIL_PV
              : "--";
            bData[3].value = data.MARKET_CROWD_DETAIL_UV
              ? data.MARKET_CROWD_DETAIL_UV
              : "--";
            fullOverview.push({
              name: "访问客户",
              data: bData,
            });
          }
          // 意向客户
          if (data) {
            let cData = [
              { label: "下单响应率", value: "0", unit: "%" },
              { label: "下单人数", value: "0", unit: "人" },
            ];
            cData[0].value = (
              (data.MARKET_CROWD_ORD_UV / data.MARKET_CROWD_UV) *
              100
            ).toFixed(2);
            if (isNaN(cData[0].value) == true) {
              cData[0].value = "--";
            }
            cData[1].value = data.MARKET_CROWD_ORD_UV
              ? data.MARKET_CROWD_ORD_UV
              : "--";
            fullOverview.push({
              name: "下单人数",
              data: cData,
            });
          }
          // 成交客户数据
          if (data) {
            let pData = [
              { label: "成交响应率：", value: "0", unit: "%" },
              { label: "成交客户数：", value: "0", unit: "人" },
              { label: "成交总金额：", value: "0", unit: "元" },
            ];
            pData[0].value = (
              (data.MARKET_CROWD_PAY_UV / data.MARKET_CROWD_UV) *
              100
            ).toFixed(2);
            if (isNaN(pData[0].value) == true) {
              pData[0].value = "--";
            }
            pData[1].value = data.MARKET_CROWD_PAY_UV
              ? data.MARKET_CROWD_PAY_UV
              : "--";
            pData[2].value = data.MARKET_CROWD_PAY_AMT
              ? data.MARKET_CROWD_PAY_AMT
              : "--";
            fullOverview.push({
              name: "成交客户",
              data: pData,
            });
          }
          this.fullOverview = fullOverview;
          this.isquery = true;
        }
      });
    },
    afterConfig(options) {
      options.xAxis.boundaryGap = false;
      return options;
    },
    close() {
      this.viewVisible = false;
    },
  },
};
</script>

<style lang="less">
.box {
  width: 275px;
  height: 241px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 1px solid #dddddd;
  display:inline-block;
  .boxTitle {
    height: 44px;
    line-height: 44px;
    background: #f6f6f6;
    border-radius: 8px 8px 0px 0px;
    opacity: 1;
    padding-left: 15px;
    .divison {
      vertical-align: middle;
      border-radius: 3px;
      width: 3px;
      height: 14px;
      background-color: #fe4d45;
      display: inline-block;
      margin: auto 4px auto 12px;
    }
  }
  .contenClass{
    padding:16px 15px;
    line-height:27px;
  }
}
.tips-content {
  float: left;
  .alert_box {
    padding: 5px;
    width: 600px;
    background: #fffaee;
    opacity: 1;
    font-weight: 400;
    position: relative;
    margin-top: -10px;
    margin-bottom: 20px;
    .alert {
      opacity: 1;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      line-height: 21px;
      padding: 0 0 0 16px;
    }
    .icon_i {
      display: inline-block;
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      margin: -14px 0 0 -22px;
    }
  }
  .icon_i {
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background-color: #fe8f8a;
    color: #fff;
    font-size: 10px;
    text-align: center;
    line-height: 14px;
    font-weight: bold;
    top: 18px;
    left: 16px;
  }
  span {
    display: block;
    font-size: 14px;
    color: #ff7600;
    line-height: 22px;
  }
}
.titleClass {
  color: red;
  // background-color:#ccc;
  padding: 0px !important;
}
.viewROI {
  padding-bottom: 10px;
  text-align: left;
  user-select: none;
  span {
    color: red;
  }
}
.v-charts-data-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: hsla(0, 0%, 100%, 0.9);
  color: #888;
  font-size: 14px;
}
.goods-title:hover {
  color: #364ecf;
  cursor: pointer;
  text-decoration: underline;
}
.table-box {
  overflow: hidden;
  margin-top: 12px;
  .shops-goods {
    position: relative;
    .goods-left {
      float: left;
      width: 100px;
      .goods-img {
        width: 80px;
        float: left;
        margin: 20px 10px 10px 10px;
      }
    }
    .goods-right {
      // margin: 10px;
      font-size: 16px;
      height: 100px;
      float: right;
      text-align: left;
      width: 300px;
    }
  }

  overflow: hidden;

  .goods-content {
    float: left;
    width: 340px;
    .goods-title {
      display: block;
      text-align: left;
      margin-bottom: 6px;
    }
    .goods-title:hover {
      color: #364ecf;
      cursor: pointer;
      text-decoration: underline;
    }
    .goods-detail {
      display: block;
      overflow: hidden;
      .goods-id {
        display: block;
        float: left;
        font-size: 14px;
      }
      .goods-price {
        display: block;
        float: right;
        .price {
          font-size: 20px;
        }
      }
    }
  }
  .add-button {
    font-size: 24px;
    cursor: pointer;
  }
  .addDisabled {
    cursor: not-allowed;
  }

  .table-right {
    float: right;
    overflow: hidden;
    .is-select {
      color: #ff7600;
    }
    .goods-img {
      width: 80px;
      float: left;
      margin-right: 10px;
    }
    .goods-content {
      float: left;
      width: 340px;
      .goods-title {
        display: block;
        text-align: left;
        margin-bottom: 6px;
      }
      .goods-title:hover {
        color: #364ecf;
        cursor: pointer;
        text-decoration: underline;
      }
      .goods-detail {
        display: block;
        overflow: hidden;
        .goods-id {
          display: block;
          float: left;
          font-size: 12px;
        }
        .goods-price {
          display: block;
          float: right;
          .price {
            font-size: 20px;
          }
        }
      }
    }
    .delete-button {
      font-size: 24px;
      cursor: pointer;
    }
  }
}
</style>
